import { Badge, carrierStatusTone, formatTimeAgo, toneFor } from '@platform/design-system';
import { usePageContext } from '../usePageContext.ts';
import type { Order } from './orders.ts';
import styles from './Orders.module.css';

export type CarrierStatusProps = {
  dispatch: Pick<Order['dispatch'], 'carrierStatus' | 'carrierStatusAt'>;
};

export const CarrierStatus = ({ dispatch }: CarrierStatusProps) => {
  const { t, locale } = usePageContext();
  if (dispatch.carrierStatus === null)
    return <span className={styles['muted']}>{t('orders.carrierStatusNone')}</span>;
  return (
    <span className={styles['stacked']}>
      <Badge tone={toneFor(carrierStatusTone, dispatch.carrierStatus)}>{dispatch.carrierStatus}</Badge>
      {dispatch.carrierStatusAt === null ? null : (
        <span className={styles['muted']}>{formatTimeAgo(dispatch.carrierStatusAt, locale, new Date())}</span>
      )}
    </span>
  );
};
